<template>
    <div class="content">
        <div class="page_searcher">
            <Searcher :items="config.searchers" @search="getData" ref="searcher"/>
        </div>
        <div class="page_block_container">
            <div class="page_block" v-for="(mod, index) in datas" :key="`mod_${index}`" :style="mod.module_style">
            <div class="page_block_content">
                <h3 v-html="`${mod.name?mod.name:mod.title?mod.title:''}${mod.desc?`<div style='color: #999; font-size: 13px; font-weight: normal; margin-left: 30px; display:inline-block'>${mod.desc}</div>`:''}`"></h3>
                
                <h3 v-if="mod.no_chart!=true" style="overflow:hidden">
                    <ChartTrans v-if="mod.chart.summary && mod.chart.type!='mixin'" :fields="mod.fields" :chart="mod.chart" :datas="mod.datas" v-model="mod.trans_chart"  style="float:right"/>
                </h3>
                <Chart v-if="mod.no_chart!=true" :datas="mod.trans_chart?mod.trans_chart.data:mod.datas" :fields="mod.fields" :conf="mod.trans_chart?mod.trans_chart.config:mod.chart" :height="400"/>
                <a-divider dashed style="margin:20px 0 10px 0" v-if="mod.no_chart!=true && mod.no_table!=true"/>
                <div class="page-block-info" style="padding: 0 0 20px 0px;" v-html="getInfo(undefined, mod.infos, mod.datas)" v-if="(mod.infos && mod.infos.text)"></div>
                <h3 v-if="mod.no_table!=true">
                    <a-button-group style="float:right; margin:0 0 10px 10px" >
                        <a-button @click="lockHeader(index)" :type="locks.indexOf(index)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(index)>=0?$t("common.cancelFix"):$t("common.fixHead")}}</a-button>
                        <a-button @click="exportToExcel(index)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>{{$t("common.downloadData")}}</a-button>
                        <a-button @click="copy(index)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>{{$t("common.copyData")}}</a-button>
                    </a-button-group>
                </h3>
                <DataTable  v-if="mod.no_table!=true" :liucun="mod.liucun" :fields="mod.fields" :theads="mod.theads"  :show_index="mod.show_index"
                :datas="mod.datas" :ref="`datatable_${index}`" :pageSize="mod.pageSize!=null?mod.pageSize:config.pageSize" :marks="marks" :color="mod.color?mod.color:config.color" :xlen="mod.xlen"  :small="true"/>
            </div>
            </div>
        </div>
    </div>
</template>  

<script>
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Searcher from '@/components/common/search/searcher.vue'
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import ChartTrans from '@/components/common/chart/chart_trans.vue'
import Mark from '@/components/common/chart/mark.vue'
export default {
    mixins: [ctrlMixin],
    components: {
        Searcher,
        DataTable,
        Chart,
        Mark,
        ChartTrans,
    },
    methods: {
        // 获取页面数据
        getData(params) {
            this.loading = true
            let datas = []
            this.$service.query(this.queryId, params).then((data)=>{
                data.forEach((row, index)=>{
                  if(this.modules.length > index) {
                    if(row instanceof Array) {
                      datas.push({...this.modules[index], datas: row})
                    }
                    else {
                      datas.push({...this.modules[index], ...row})
                    }
                  }
                  else {
                    if(!(row instanceof Array)) {
                      datas.push(row)
                    }
                  }
                })
                datas.forEach(d=>{
                    if(d.fixedH || d.fixedW) {
                        d.module_style = `${d.module_style || ''}${d.fixedW?`width:${d.fixedW}; overflow: auto;`:''}${d.fixedH?`height:${d.fixedH}; overflow: auto;`:''}`
                    }
                })
                this.datas = datas
                this.loading = false
            }).catch((data)=> {
                this.datas = datas
                this.loading = false
            })
        }
    },
    data() {
        return {
            datas:[],
            current:0,
        }
    },
}
</script>

<style lang="less">
.page_block_container {
    display: flex;
    flex-wrap:wrap;
    .page_block {
        width: 100%;
    }
}
</style>